
// /* eslint-disable */
// /* eslint-disable react/button-has-type */
// import React, { useState } from 'react';
// import Select from 'react-select';
// import DashboardSection from '../../../DashboardContainer/DashboardSection';
// import DomainTile from '../../../DomainTile/DomainTile';
// import styles from '../../MainDashboard/MainDashboard.module.css';
// import ReusableTable from '../../../ReusableTable/ReusableTable';

// const entityOptions = [
//   { value: 'undefined', label: 'Select' },
//   { value: 'All', label: '-All-' },
//   { value: 'domastic', label: 'Domastic' },
//   { value: 'international', label: 'International' },
// ];

// const yearOptions = [
//   { value: 'All', label: '(All)' },
//   { value: '2025', label: '2025' },
//   { value: '2024', label: '2024' },
// ];

// const quarterOptions = [
//   { value: 'All', label: '(All)' },
//   { value: 'Q1', label: 'Q1' },
//   { value: 'Q2', label: 'Q2' },
//   { value: 'Q3', label: 'Q3' },
//   { value: 'Q4', label: 'Q4' },
// ];

// const monthOptions = [
//   { value: 'All', label: '(All)' },
//   { value: 'Jan', label: 'Jan' },
//   { value: 'Feb', label: 'Feb' },
//   { value: 'Mar', label: 'Mar' },
//   { value: 'Apr', label: 'Apr' },
//   { value: 'May', label: 'May' },
//   { value: 'Jun', label: 'Jun' },
//   { value: 'Jul', label: 'Jul' },
//   { value: 'Aug', label: 'Aug' },
//   { value: 'Sep', label: 'Sep' },
//   { value: 'Oct', label: 'Oct' },
//   { value: 'Nov', label: 'Nov' },
//   { value: 'Dec', label: 'Dec' },
// ];




// function DetailNoticeTable() {

//   const columns = [
//     { header: 'srNo', accessor: 'Sr. No.', width: '60px' },
//     { header: 'dateofnotice', accessor: 'Date Of Notice'},
//     {header: 'AY' , accessor: 'AY'},
//     { header: 'Authority', accessor: 'Authority' },
//     { header: 'Particulars', accessor: 'Particulars(Section)'},
//     { header: 'dueDate', accessor: 'Due Date for Compliance'},
//     { header: 'actualdateofcompliance', accessor: 'Actualdateofcompliance'},
//     { header: 'remarks', accessor: 'Remarks' }
//   ];
// const data = [
//   {
//     'Sr. No.': 1,
//     'Date Of Notice': '2025-05-10',
//     'AY': '2023-24',
//     'Authority': 'Income Tax Dept.',
//     'Particulars(Section)': 'Section 143(1)',
//     'Due Date for Compliance': '2025-06-10',
//     'Actualdateofcompliance': '2025-06-08',
//     'Remarks': 'Submitted on time'
//   },
//   {
//     'Sr. No.': 2,
//     'Date Of Notice': '2025-07-01',
//     'AY': '2024-25',
//     'Authority': 'GST Dept.',
//     'Particulars(Section)': 'Section 61',
//     'Due Date for Compliance': '2025-07-15',
//     'Actualdateofcompliance': '',
//     'Remarks': 'Pending submission'
//   }
// ];
//   const [entity, setEntity] = useState(entityOptions[0]);
//       const [year, setYear] = useState(yearOptions[0]);
//       const [quarter, setQuarter] = useState(quarterOptions[0]);
//       const [month, setMonth] = useState(monthOptions[0]);
//       const handleApply = () => {
//     console.log('Apply clicked with:', {
//       year: year.value,
//       quarter: quarter.value,
//       month: month.value,
//     });
//   };

//   const handleReset = () => {
//     setEntity(entity[0]);
//     setYear(yearOptions[0]);
//     setQuarter(quarterOptions[0]);
//     setMonth(monthOptions[0]);
//   };
//   return (
//      <>
//       <div className={styles.filter_panel_container}>
//         <div className={styles.filter_panel_row}>
//           <div className={styles.filter_panel_col}>
//             <label className={styles.filter_label}>Entity</label>
//             <div className={styles.filter_select_wrapper}>
//               <Select
//                 value={entity}
//                 onChange={setEntity}
//                 options={entityOptions}
//                 isSearchable={false}
//               />
//             </div>
//           </div>

//           <div className={styles.filter_panel_col}>
//             <label className={styles.filter_label}>Year</label>
//             <div className={styles.filter_select_wrapper}>
//               <Select
//                 value={year}
//                 onChange={setYear}
//                 options={yearOptions}
//                 isSearchable={false}
//               />
//             </div>
//           </div>
//           <div className={styles.filter_panel_col}>
//             <label className={styles.filter_label}>Quarter</label>
//             <div className={styles.filter_select_wrapper}>
//               <Select
//                 value={quarter}
//                 onChange={setQuarter}
//                 options={quarterOptions}
//                 isSearchable={false}
//               />
//             </div>
//           </div>
//           <div className={styles.filter_panel_col}>
//             <label className={styles.filter_label}>Month</label>
//             <div className={styles.filter_select_wrapper}>
//               <Select
//                 value={month}
//                 onChange={setMonth}
//                 options={monthOptions}
//                 isSearchable={false}
//               />
//             </div>
//           </div>
//           <div className="filter-panel-col action-buttons">
//             <button onClick={handleApply} className="btn apply-btn">
//               Apply
//             </button>
//             <button onClick={handleReset} className="btn reset-btn">
//               Reset
//             </button>
//           </div>
//         </div>
//       </div>
//       <div className="row">
//           <div className="col-md-12">
//               <DomainTile title='Departmental Notices'  showBackButton={true}/>
//           </div>
//         </div>

//     <DashboardSection title='' disableDetailView={true}>
//       <ReusableTable columns={columns} data={data} />
//     </DashboardSection>
//   </>
//   );
// }

// export default DetailNoticeTable ;

// ####################### New Pages ##############################
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Select from 'react-select';
import config from '../../../../config/config';
import DashboardSection from '../../../DashboardContainer/DashboardSection';
import DomainTile from '../../../DomainTile/DomainTile';
import ReusableTable from '../../../ReusableTable/ReusableTable';
import styles from './DeatiledPageComp.module.css';
import './DeatiledPageComp.css';

const { API_BASE_URL } = config;

const quarterOptions = [
  { value: 'Q1', label: 'Q1' },
  { value: 'Q2', label: 'Q2' },
  { value: 'Q3', label: 'Q3' },
  { value: 'Q4', label: 'Q4' },
];

const monthOptions = [
  { value: '01', label: 'Jan' },
  { value: '02', label: 'Feb' },
  { value: '03', label: 'Mar' },
  { value: '04', label: 'Apr' },
  { value: '05', label: 'May' },
  { value: '06', label: 'Jun' },
  { value: '07', label: 'Jul' },
  { value: '08', label: 'Aug' },
  { value: '09', label: 'Sep' },
  { value: '10', label: 'Oct' },
  { value: '11', label: 'Nov' },
  { value: '12', label: 'Dec' },
];

const DetailNoticeTable = () => {

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const initialFilters = location.state || {
    entityData: null,
    geographyData: null,
    yearData: null,
    monthData: null,
    quarterData: null,
  };

  const [hasApplied, setHasApplied] = useState(false);
  
  const [filters, setFilters] = useState(initialFilters);

  // console.log("data test treadmark--------------->", entityData, geographyData, yearData, quarterData, monthData);

  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  // const [monthOptions, setMonthOptions] = useState([]);
  // const [quarterOptions, setQuarterOptions] = useState([]);

  // const [entity, setEntity] = useState(entityOptions[0]);
  const [entity, setEntity] = useState([]);
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [quarter, setQuarter] = useState([]);

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1); 
  const itemsPerPage = 10;
  const [selectedPage, setSelectedPage] = useState(1);

  const [data, setData] = useState([]);

  const fetchData = (filters) => {
    // console.log("Fetching with", filters);
  };

  useEffect(() => {
    fetchData(filters);
  }, []);


  const handleEntityChange = (selected) => {
    setEntity(selected);
    setFilters(prev => ({ ...prev, entityData: selected }));
  };

  // const handleEntityChange = (selected) => {
  //   setEntity(selected || []);
  //   setFilters((prev) => ({ ...prev, entityData: selected || [] }));
  // };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters(prev => ({ ...prev, yearData: selected }));
  };

  const handleMonthChange = (selected) => {
    setMonth(selected);
    setFilters(prev => ({ ...prev, monthData: selected }));
  };

  const handleQuarterChange = (selected) => {
    setQuarter(selected);
    setFilters(prev => ({ ...prev, quarterData: selected }));
  };

  const handleApply = () => {
    const entityFilter = filters.entityData.value || '';
    // const entityFilter = entity.map(e => e.value);
    const yearFilter = year?.value === 'All' ? '' : year?.value || '';
    const monthFilter = month?.value === 'All' ? '' : month?.value || '';
    const page = selectedPage || 1;
    const limit = itemsPerPage;
    const offset = (page - 1) * limit;

    const fetchDomainCompData = async () => {
      setdataLoading(true);
      try {
        const response = await axios.post(`${API_BASE_URL}/api/direct-tax-deptnotice-drilldown`, 
          {
            entity: entityFilter,
            year: yearFilter,
            month: monthFilter,
            limit: limit,
            offset: offset,
          },
          {
            headers: {
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        );

        // console.log("Trademark data received:", response.data);
        setData(response.data.data);
        setTotalRecords(response.data.total);
      } catch (error) {
        console.error('Error fetching trademark data:', error);
      } finally {
        setdataLoading(false);
      }
    };

    fetchDomainCompData();
  };


  const handleCSVDownload = async () => {
    try {
      // const entityFilter = entity.map(e => e.value);
      const entityFilter = filters.entityData.value || '';
      const yearFilter = year?.value === 'All' ? '' : year?.value || '';
      const monthFilter = month?.value === 'All' ? '' : month?.value || '';
      const bodyData = {
        entity: entityFilter,
        year: yearFilter,
        month: monthFilter,
      };

      const response = await fetch(`${API_BASE_URL}/api/direct-tax-deptnotice-drilldown-Download`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        throw new Error("Failed to download CSV");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "direct_tax_dept_notice_data.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const handleReset = () => {
    setEntity([]);
    setYear(null);
    setQuarter(null);
    setMonth(null);
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/direct-tax-entity`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setEntityOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/direct-tax-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setYearOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchYearOptions();
    // fetchMonthOptions();
  }, []);

  useEffect(() => {
    // console.log("test log -------------->",entityOptions.length, quarterOptions.length, yearOptions.length, monthOptions.length);
    
    if (entityOptions.length && quarterOptions.length && yearOptions.length && monthOptions.length) {
      if (filters.entityData) {
        const ent = entityOptions.find(opt => opt.value === filters.entityData.value);
        if (ent) setEntity(ent);
      }
      // if (filters.entityData?.length) {
      //   const ents = entityOptions.filter(opt =>
      //     filters.entityData.some(f => f.value === opt.value)
      //   );
      //   setEntity(ents);
      // }

      if (filters.yearData) {
        const yr = yearOptions.find(opt => opt.value === filters.yearData.value);
        if (yr) setYear(yr);
      }

      if (filters.monthData) {
        const mon = monthOptions.find(opt => opt.value === filters.monthData.value);
        if (mon) setMonth(mon);
      }

      if (filters.quarterData) {
        const qtr = quarterOptions.find(opt => opt.value === filters.quarterData.value);
        if (qtr) setQuarter(qtr);
      }

      // console.log("selectd data dropdown ----------------->", entity, year, month);

      setHasApplied(true);
      // if (entity) {
      //   setTimeout(() => {
      //     handleApply();
      //   }, 1000);
      // }
    }
  }, [entityOptions, quarterOptions, yearOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied === true && filters.entityData !== null) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);


  const columns = [
    { header: "Sr. No.", accessor: "sr_no" },
    { header: "Date of Notice", accessor: "date_of_notice" },
    { header: "AY", accessor: "ay" },
    { header: "Authority", accessor: "authority" },
    { header: "Particulars (Section)", accessor: "particulars_section" },
    { header: "Due date of compliance", accessor: "due_date_of_compliance" },
    { header: "Actual Date of Compliance", accessor: "actual_date_of_compliance" },
    { header: "Remarks", accessor: "remarks" },
  ];

  // "Sr. No.","Date of Notice","AY","Authority","Particulars (Section)","Due date of compliance","Actual Date of Compliance","Remarks"


  const handlePageChange = (page) => {
    setSelectedPage(page);
    setCurrentPage(page);
    handleApply();
  };

  const [dataLoading, setdataLoading] = useState(false);

  const customStyles = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 3000,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 3000,
    }),
  };

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                // isMulti
                value={entity}
                // onChange={setEntity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={false}
                placeholder="Select Entity"
                // closeMenuOnSelect={false}
                // styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                // onChange={setYear}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                // onChange={setMonth}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                // onChange={setQuarter}
                onChange={handleQuarterChange}
                options={quarterOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      <div>
        <div className="row">
          <div className="col-md-12">
            <DomainTile title='Departmental Notices' showBackButton={true} mainPagePath="/Direct-Tax" detailState = {filters}/>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DashboardSection title="" disableDetailView={true}>
              {/* <h2> tabel here</h2> */}
              <ReusableTable
                data={data} columns={columns} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={totalRecords} handleCSVDownload={handleCSVDownload} dataLoading={dataLoading}
              />
            </DashboardSection>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailNoticeTable;